import { directusClient } from "../../hooks/useDirectus";

export async function getGames() {
    let { data: games } = await directusClient.getItems(`game`, {});
    return games;
}
